<template>
  <div class="py-8 px-6 md:px-10 md:max-w-sm">
    <button class="absolute top-5 right-5" @click="close">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M18.6404 20.1804L12.0004 13.5405L5.36113 20.1804C5.25999 20.2815 5.13952 20.3615 5.00737 20.4162C4.87522 20.4709 4.73381 20.5 4.59077 20.5C4.44773 20.5 4.30632 20.4709 4.17417 20.4162C4.04202 20.3615 3.92155 20.2815 3.8204 20.1804C3.71926 20.0793 3.6393 19.9604 3.58456 19.8282C3.52983 19.6961 3.50155 19.5539 3.50155 19.4109C3.50155 19.2679 3.52983 19.1257 3.58456 18.9936C3.6393 18.8615 3.71926 18.741 3.8204 18.6399L10.4612 12.0031L3.8204 5.3632C3.61551 5.15897 3.50045 4.88145 3.5 4.59217C3.49955 4.30289 3.61381 4.02601 3.81808 3.82114C4.02234 3.61627 4.2999 3.50045 4.58922 3.5C4.87854 3.49955 5.15624 3.6138 5.36113 3.81803L12.0019 10.461L18.6404 3.82424C18.8446 3.62011 19.1213 3.50621 19.41 3.50621C19.6987 3.50621 19.9754 3.62011 20.1796 3.82424C20.3838 4.02837 20.4984 4.30504 20.4984 4.59372C20.4984 4.88241 20.3838 5.15907 20.1796 5.3632L13.5411 12.0015L20.1796 18.6414C20.2811 18.7423 20.362 18.863 20.417 18.9951C20.472 19.1273 20.5 19.2678 20.5 19.4109C20.5 19.5541 20.472 19.6961 20.417 19.8282C20.362 19.9604 20.2811 20.081 20.1796 20.182C20.0791 20.2833 19.9601 20.3632 19.8282 20.4178C19.6963 20.4723 19.5543 20.5008 19.4116 20.5C19.2683 20.5005 19.1266 20.4724 18.9942 20.4178C18.8618 20.3631 18.7416 20.2818 18.6404 20.1804Z"
          fill="#B1B1B1"
        />
      </svg>
    </button>
    <div v-if="success" class="flex flex-col items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M40 0.449219C17.9455 0.449219 0 18.3947 0 40.4492C0 62.5038 17.9455 80.4492 40 80.4492C62.0545 80.4492 80 62.5038 80 40.4492C80 18.3947 62.0545 0.449219 40 0.449219ZM40 75.9038C20.4545 75.9038 4.54545 59.9947 4.54545 40.4492C4.54545 20.9038 20.4545 4.99467 40 4.99467C59.5455 4.99467 75.4545 20.9038 75.4545 40.4492C75.4545 59.9947 59.5455 75.9038 40 75.9038Z"
          fill="#128750"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57.9273 23.3129V23.1765C56.9727 23.1765 56.0182 23.7219 55.4636 24.4038L34.2818 48.9947L24.3091 38.7492C22.9455 37.3856 20.6182 37.2492 19.2545 38.7492C17.8909 40.1129 17.7545 42.4401 19.2545 43.8038L31.9636 56.9219C33.3273 58.4219 35.6545 58.4219 37.0182 56.9219C37.0182 56.9219 37.1545 56.7856 37.2909 56.6492L60.9273 29.1856C62.2909 27.6856 62.0182 25.3583 60.5182 24.131C59.8364 23.4492 58.8818 23.1765 57.9182 23.3129H57.9273Z"
          fill="#128750"
        />
      </svg>
      <p class="text-lg-bold pt-6 pb-2">Your password has been updated</p>
      <p class="text-base self-left">You will receive a confirmation email shortly.</p>
      <div class="pt-8 w-full">
        <button type="button" class="btn btn-md btn-secondary w-full" @click="close">Close</button>
      </div>
    </div>
    <div v-else-if="fail" class="flex flex-col items-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
        <path
          d="M40 -0.00463867C17.9402 -0.00463867 0 17.7317 0 39.5408V40.459C0 62.259 17.9402 80.0045 40 80.0045C62.0598 80.0045 80 62.2681 80 40.459V39.5408C79.9908 17.7317 62.0506 -0.00463867 40 -0.00463867ZM75.3931 40.4499C75.3931 59.7499 59.5126 75.4499 39.9908 75.4499C20.469 75.4499 4.5977 59.7499 4.5977 40.4499V39.5317C4.5977 20.2408 20.4782 4.54082 40 4.54082C59.5218 4.54082 75.4023 20.2408 75.4023 39.5408V40.459L75.3931 40.4499Z"
          fill="#D82900"
        />
        <path
          d="M55.2736 24.5681C54.1977 23.5045 52.4506 23.5045 51.3747 24.5681L39.669 36.1408L28.6161 25.2135C27.5402 24.1499 25.7931 24.1499 24.7172 25.2135C23.6414 26.2772 23.6414 28.0045 24.7172 29.0681L35.7701 39.9954L24.7172 50.9226C23.6414 51.9863 23.6414 53.7135 24.7172 54.7772C25.7931 55.8408 27.5402 55.8408 28.6161 54.7772L39.669 43.8499L51.3747 55.4226C52.4506 56.4863 54.1977 56.4863 55.2736 55.4226C56.3494 54.359 56.3494 52.6317 55.2736 51.5681L43.5678 39.9954L55.2736 28.4226C56.3494 27.359 56.3494 25.6317 55.2736 24.5681Z"
          fill="#D82900"
        />
      </svg>
      <p class="text-lg-bold pt-6 pb-2">Unable to update your password</p>
      <p class="text-base self-left mb-6">We are having trouble processing your request.</p>
      <p class="text-base self-left">
        Please contact us on <a href="tel:131905">13 1905</a> to get help if the issue persists.
      </p>
      <div class="pt-8 w-full">
        <button type="button" class="btn btn-md btn-secondary w-full" @click="close">Close</button>
      </div>
    </div>
    <FormKit v-else v-model="passwordDetails" type="form" @submit="handleSubmit">
      <fieldset>
        <Text v-if="fields?.title.value" :field="fields.title" tag="legend" class="text-center text-lg-bold pb-6" />
        <PasswordInput :key="passComponentKey" />
        <div class="flex flex-col gap-4 mt-8">
          <button type="submit" class="btn btn-md btn-primary w-full">Change password</button>
          <button type="button" class="btn btn-md btn-secondary w-full" @click="close">Discard changes</button>
        </div>
      </fieldset>
    </FormKit>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ComponentFields } from '@sitecore-jss/sitecore-jss/types/layout';
import PasswordInput from '../PasswordInput/PasswordInput.vue';
import { Text } from '@sitecore-jss/sitecore-jss-vue';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------
const props = defineProps<{
  fields?: ComponentFields;
}>();

const passwordDetails = ref<Record<string, string>>({});
const passComponentKey = ref<string>('initialKey');
const success = ref<boolean>(false);
const fail = ref<boolean>(false);

function handleSubmit() {
  // TODO for testing only
  success.value = true;
}
</script>
